import { ref } from 'vue'

const deferredPrompt = ref<any | null>(null)
const showInstallPrompt = ref(false)

export function usePwa() {
    function setDeferredPrompt(e: Event | null) {
        deferredPrompt.value = e
        showInstallPrompt.value = !!e
    }

    async function onInstallClick() {
        if (deferredPrompt.value) {
            try {
                deferredPrompt.value.prompt()
                await deferredPrompt.value.userChoice
            } catch (err) {
                // ignore
            }
            deferredPrompt.value = null
            showInstallPrompt.value = false
        }
    }

    function handleAppInstalled() {
        deferredPrompt.value = null
        showInstallPrompt.value = false
    }

    return {
        deferredPrompt,
        showInstallPrompt,
        setDeferredPrompt,
        onInstallClick,
        handleAppInstalled,
    }
}
